/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

export interface CheckmarkIconProps extends IconProps {
  className?: string;
}

/*
 * Defines the Design Language System (DLS) Checkmark Icon component.
 */
export const CheckmarkIcon = ({
  size = IconSize.small,
  color = dlsColor('caGreen'),
  className = ''
}: CheckmarkIconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});

  return (
    <svg className={className} width={iconSize} height={iconSize} viewBox="0 0 16 17" fill="none">
      <path d="M13.0625 5.32149L6.1625 12.2215L3 9.05899L3.81075 8.24824L6.1625 10.5942L12.2517 4.51074L13.0625 5.32149Z" fill={iconColor} />
    </svg>
  );
};
